import type { ChartConfig } from '../chart-utils';

export const DoubleMaterialityChartLegend = ({
  config,
  chartColors,
}: {
  config: Pick<ChartConfig, 'code' | 'categories'>;
  chartColors: string[];
}) => {
  return (
    <div className='d-flex justify-content-end ml-auto text-xs gap-2'>
      {Object.values(config.categories).map(({ label }, index) => (
        <div className='d-flex align-items-center gap-1' key={label}>
          <div className='legend-color-item' style={{ backgroundColor: chartColors[index ?? 0] }} />
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
};
